var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1708_31776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76563 2.64062C8.76563 2.43757 8.68496 2.24283 8.54138 2.09925C8.3978 1.95566 8.20306 1.875 8 1.875C7.79694 1.875 7.6022 1.95566 7.45862 2.09925C7.31504 2.24283 7.23438 2.43757 7.23438 2.64062V7.23438H2.64062C2.43757 7.23438 2.24283 7.31504 2.09925 7.45862C1.95566 7.6022 1.875 7.79694 1.875 8C1.875 8.20306 1.95566 8.3978 2.09925 8.54138C2.24283 8.68496 2.43757 8.76563 2.64062 8.76563H7.23438V13.3594C7.23438 13.5624 7.31504 13.7572 7.45862 13.9008C7.6022 14.0443 7.79694 14.125 8 14.125C8.20306 14.125 8.3978 14.0443 8.54138 13.9008C8.68496 13.7572 8.76563 13.5624 8.76563 13.3594V8.76563H13.3594C13.5624 8.76563 13.7572 8.68496 13.9008 8.54138C14.0443 8.3978 14.125 8.20306 14.125 8C14.125 7.79694 14.0443 7.6022 13.9008 7.45862C13.7572 7.31504 13.5624 7.23438 13.3594 7.23438H8.76563V2.64062Z",
    fill: "#0065FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1708_31776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBlue);
export default __webpack_public_path__ + "static/media/plusIconBlue.a3407588a7707612d77a05e27cd7b74a.svg";
export { ForwardRef as ReactComponent };